import { Box } from '@mui/material'

export default function DrawerHeader() {
  return (
    <Box
      sx={{
        backgroundColor: 'white',
        height: '24px',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'gray',
          height: '8px',
          width: 20,
          borderRadius: 10,
          mx: 'auto',
          mt: 1,
        }}
      />
    </Box>
  )
}
